import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { formatDateWithTooltip } from '../../utils';
import withTranslations from '../../utils/HighOrderComponent';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import authorizationService from '../../securityUtils/authorizationService';
import { actionsDecision } from '../../constants/globals';

class DecisionRow extends Component {
  onDeleteClick = (id) => {
    const { t, gt, deleteDecision } = this.props || {},
      { ConfirmDialog } = t || {},
      { confirmDelete } = ConfirmDialog || {};
    const action = () => {
      deleteDecision(id);
    };
    confirmDialog(t.confirmMessage, action, confirmDelete, gt);
  };

  downloadDecision = () => {
    const { NotificationMessages } = this.props.t || {};
    const { embeddableAttribute } =
      this.props.decision?.decisionAttachment || {};
    const { uuidName, name } = embeddableAttribute;
    this.props.downloadDecisionAttachment(uuidName, name, NotificationMessages);
  };

  render() {
    const { index, decision, enums } = this.props || {},
      { decisionType, dateCreated, requestForSignetApproval, allowedActions } =
        decision || {},
      { DecisionStatus } = enums || {};

    const actions = allowedActions || [];
    const decisionStatus = DecisionStatus[decision.decisionStatus];

    const isDecisionDownloadAllowed = authorizationService.isActionAllowed(
      actionsDecision.DOWNLOAD_DECISION,
      actions
    );

    const tdStyle = !isDecisionDownloadAllowed
      ? 'preview-style text-center'
      : 'text-center';

    const labelStyle = !isDecisionDownloadAllowed
      ? 'fas fa-download faded-letter'
      : 'fas fa-download';

    const decisionRow = (
      <tr className="text-center">
        <td>{index}</td>
        <td>{requestForSignetApproval.referenceNumber}</td>
        <td>{decisionStatus?.text}</td>
        <td>{decisionType?.name}</td>
        <td className="text-center">
          {dateCreated && formatDateWithTooltip(dateCreated)}
        </td>
        <td disabled className={tdStyle}>
          <Link onClick={this.downloadDecision} to="#">
            <i className={labelStyle}></i>
          </Link>
        </td>
      </tr>
    );

    return <Fragment>{decisionRow}</Fragment>;
  }
}

export default withTranslations(DecisionRow, 'DecisionRow');
